module.exports = __webpack_public_path__ + "static/media/DoctorManhattan.523c8e27.png";